/**
 * Длительность видеофайла средствами браузера. Нужна как фолбэк для сервера
 * без ffprobe (docs/API.md, раздел «Видео»).
 */
export function probeVideoDuration(file: File): Promise<number | null> {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const video = document.createElement('video')
    video.preload = 'metadata'
    let settled = false
    const finish = (value: number | null): void => {
      if (settled) return
      settled = true
      URL.revokeObjectURL(url)
      video.removeAttribute('src')
      video.load()
      resolve(value)
    }
    video.onloadedmetadata = (): void => {
      finish(Number.isFinite(video.duration) ? video.duration : null)
    }
    video.onerror = (): void => finish(null)
    window.setTimeout(() => finish(null), 8000)
    video.src = url
  })
}

export function pickFile(accept: string): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = accept
    input.onchange = (): void => resolve(input.files?.[0] ?? null)
    // Диалог могли закрыть без выбора — тогда onchange не придёт и промис
    // просто не разрешится; это безопасно, ссылка на input умрёт с ним.
    input.click()
  })
}

export const VIDEO_ACCEPT = 'video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov'
export const MAX_VIDEO_BYTES = 512 * 1024 * 1024
